import React from 'react';
import { Building2, Store, Home, MapPin, FileCheck, Landmark } from 'lucide-react';

const DealingIn = () => {
  const dealingItems = [
    {
      id: 1,
      title: 'Authority Plots',
      icon: Building2,
      description: 'Authorized residential and commercial plots from government development authorities'
    },
    {
      id: 2,
      title: 'Commercial Plots',
      icon: Store,
      description: 'Prime commercial land in strategic locations for business growth'
    },
    {
      id: 3,
      title: 'Group Housing',
      icon: Home,
      description: 'Well-planned residential group housing projects with modern amenities'
    },
    {
      id: 4,
      title: 'Township',
      icon: MapPin,
      description: 'Integrated township developments with complete infrastructure'
    },
    {
      id: 5,
      title: 'Laal Dora {Aabadi} Freehold',
      icon: FileCheck,
      description: 'Freehold properties in Laal Dora areas with clear ownership rights'
    },
    {
      id: 6,
      title: '7% Kisan Aabadi Plot',
      icon: Landmark,
      description: 'Agricultural land conversion plots with proper documentation'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            OUR CONSULTING SERVICES
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {dealingItems.map((item) => {
            const Icon = item.icon;
            return (
              <div
                key={item.id}
                className="group bg-gradient-to-br from-white to-amber-50/30 rounded-xl p-8 border-2 border-gray-100 hover:border-[#B8944A] transition-all duration-300 hover:shadow-xl"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-[#B8944A] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DealingIn;
